/**
 * NotificationCenterPage — Page wrapper for Action Queue
 * Phase 4.7.5 (WQ-170)
 */

import React from 'react';
import ActionQueue from '../components/notifications/ActionQueue';

const NotificationCenterPage: React.FC = () => {
  return <ActionQueue />;
};

export default NotificationCenterPage;
